// Traduções desta tela e do diálogo dela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'servicos.page.title': 'Serviços',
    'servicos.page.novo': 'Novo serviço',
    'servicos.page.busca': 'Buscar serviço ou descrição...',
    'servicos.page.col.servico': 'Serviço',
    'servicos.page.col.descricoes': 'Descrições do ERP',
    'servicos.page.col.viagens': 'Viagens',
    'servicos.page.semDescricao': 'Nenhuma descrição alocada',
    'servicos.page.vazio': 'Nenhum serviço cadastrado ainda.',
    'servicos.page.vazioBusca': 'Nenhum serviço para "{{busca}}".',
    'servicos.page.viagens_one': '{{count}} viagem',
    'servicos.page.viagens_other': '{{count}} viagens',
    'servicos.resumo.servicos': 'Serviços',
    'servicos.resumo.descricoes': 'Descrições do ERP',
    'servicos.resumo.semServico': 'Descrições sem serviço',
    'servicos.resumo.viagensSemServico': 'Viagens sem serviço',
    'servicos.livres.titulo': 'Descrições sem serviço',
    'servicos.livres.dica': 'Toda viagem com estas descrições sai como Sem serviço no Painel de Viagens.',
    'servicos.livres.tudoAlocado': 'Todas as descrições do ERP já têm serviço.',
    'servicos.livres.nenhuma': 'Nenhuma descrição de serviço chegou do ERP ainda.',
    'servicos.livres.semDescricao_one': '{{count}} viagem veio do ERP sem descrição e também sai como Sem serviço.',
    'servicos.livres.semDescricao_other': '{{count}} viagens vieram do ERP sem descrição e também saem como Sem serviço.',
    'servicos.dialogo.novo': 'Novo serviço',
    'servicos.dialogo.editar': 'Editar serviço',
    'servicos.dialogo.nome': 'Nome do serviço',
    'servicos.dialogo.nomeDica': 'Como a operação chama o serviço, por exemplo Prancha.',
    'servicos.dialogo.nomeObrigatorio': 'Informe o nome do serviço',
    'servicos.dialogo.descricoes': 'Descrições do ERP',
    'servicos.dialogo.descricoesDica': 'Só aparecem as descrições sem serviço e as deste serviço.',
    'servicos.dialogo.semOpcoes': 'Nenhuma descrição livre',
    'servicos.dialogo.escolhidas': 'Descrições escolhidas',
    'servicos.dialogo.nenhumaEscolhida': 'Nenhuma descrição escolhida. O serviço pode ser salvo assim e receber descrições depois.',
    'servicos.dialogo.totalDescricoes': 'Descrições',
    'servicos.dialogo.totalViagens': 'Viagens',
    'servicos.dialogo.remover': 'Tirar {{descricao}} do serviço',
    'servicos.dialogo.criado': 'Serviço {{nome}} criado',
    'servicos.dialogo.salvo': 'Serviço {{nome}} salvo',
    'servicos.apagar.titulo': 'Excluir serviço',
    'servicos.apagar.mensagem': 'O serviço {{nome}} sai do cadastro, e as descrições dele voltam para Sem serviço, com as viagens que as carregam.',
    'servicos.apagar.apagado': 'Serviço {{nome}} excluído',
    'servicos.apagar.mensagemPadrao': 'O serviço {{nome}} é o padrão. Sem ele, as viagens sem serviço e as descrições dele voltam a sair como Sem serviço no Painel de Viagens.',
    'servicos.page.padrao': 'Padrão',
    'servicos.page.padraoDica': 'Recebe toda viagem sem serviço, a que veio sem descrição e a de descrição ainda não alocada.',
    'servicos.resumo.viagensNoPadrao': 'Viagens no padrão',
    'servicos.livres.dicaPadrao': 'Toda viagem com estas descrições sai como {{nome}} no Painel de Viagens até ser alocada.',
    'servicos.livres.semDescricaoPadrao_one': '{{count}} viagem veio do ERP sem descrição e sai como {{nome}}.',
    'servicos.livres.semDescricaoPadrao_other': '{{count}} viagens vieram do ERP sem descrição e saem como {{nome}}.',
    'servicos.dialogo.padrao': 'Serviço padrão',
    'servicos.dialogo.padraoDica': 'Recebe toda viagem sem serviço, a que veio sem descrição e a de descrição ainda não alocada. Um serviço só pode ser o padrão.',
    'servicos.dialogo.padraoMove': 'Hoje o padrão é {{nome}}. Salvar move a marca para este serviço.',
    'servicos.dialogo.papel': 'Regra de viagem',
    'servicos.dialogo.papelNenhuma': 'Nenhuma',
    'servicos.dialogo.papelDica': 'O lugar deste serviço nas regras do módulo de Viagens, como o Tempo UBS e os arquivos do Protheus, que valem só para Espiga. O nome do serviço pode mudar sem desligar a regra.',
    'servicos.papel.espiga': 'Espiga',
    'servicos.papel.prancha': 'Prancha',
    'servicos.papel.diaria': 'Diária',
    'servicos.papel.outros': 'Outros',
    'servicos.page.papelDica': 'Regra de viagem deste serviço',
    'servicos.page.novoInterno': 'Novo em Outros Serviços',
    'servicos.page.grupoInterno': 'Outros Serviços',
    'servicos.page.internoDica': 'Serviço interno do HUB. Não vai para o Protheus e serve ao apontamento manual das viagens em Outros ou sem serviço.',
    'servicos.page.internoSemDescricao': 'Interno do HUB, sem descrição do ERP',
    'servicos.dialogo.novoInterno': 'Novo em Outros Serviços',
    'servicos.dialogo.internoExplica': 'Um dos Outros Serviços do HUB, como Pneu. Não recebe descrição do ERP e não vai para o Protheus: aparece no apontamento manual das viagens em Outros, em Transporte em Geral ou sem serviço.',
  },
  en: {
    'servicos.page.title': 'Services',
    'servicos.page.novo': 'New service',
    'servicos.page.busca': 'Search service or description...',
    'servicos.page.col.servico': 'Service',
    'servicos.page.col.descricoes': 'ERP descriptions',
    'servicos.page.col.viagens': 'Trips',
    'servicos.page.semDescricao': 'No description allocated',
    'servicos.page.vazio': 'No services registered yet.',
    'servicos.page.vazioBusca': 'No services for "{{busca}}".',
    'servicos.page.viagens_one': '{{count}} trip',
    'servicos.page.viagens_other': '{{count}} trips',
    'servicos.resumo.servicos': 'Services',
    'servicos.resumo.descricoes': 'ERP descriptions',
    'servicos.resumo.semServico': 'Descriptions without service',
    'servicos.resumo.viagensSemServico': 'Trips without service',
    'servicos.livres.titulo': 'Descriptions without service',
    'servicos.livres.dica': 'Every trip with these descriptions shows as No service in the Trips panel.',
    'servicos.livres.tudoAlocado': 'Every ERP description already has a service.',
    'servicos.livres.nenhuma': 'No service description has arrived from the ERP yet.',
    'servicos.livres.semDescricao_one': '{{count}} trip came from the ERP without a description and also shows as No service.',
    'servicos.livres.semDescricao_other': '{{count}} trips came from the ERP without a description and also show as No service.',
    'servicos.dialogo.novo': 'New service',
    'servicos.dialogo.editar': 'Edit service',
    'servicos.dialogo.nome': 'Service name',
    'servicos.dialogo.nomeDica': 'How operations calls the service, for example Lowboy.',
    'servicos.dialogo.nomeObrigatorio': 'Enter the service name',
    'servicos.dialogo.descricoes': 'ERP descriptions',
    'servicos.dialogo.descricoesDica': 'Only descriptions without a service and the ones of this service are listed.',
    'servicos.dialogo.semOpcoes': 'No free description',
    'servicos.dialogo.escolhidas': 'Chosen descriptions',
    'servicos.dialogo.nenhumaEscolhida': 'No description chosen. The service can be saved like this and get descriptions later.',
    'servicos.dialogo.totalDescricoes': 'Descriptions',
    'servicos.dialogo.totalViagens': 'Trips',
    'servicos.dialogo.remover': 'Remove {{descricao}} from the service',
    'servicos.dialogo.criado': 'Service {{nome}} created',
    'servicos.dialogo.salvo': 'Service {{nome}} saved',
    'servicos.apagar.titulo': 'Delete service',
    'servicos.apagar.mensagem': 'Service {{nome}} leaves the register, and its descriptions go back to No service, along with the trips that carry them.',
    'servicos.apagar.apagado': 'Service {{nome}} deleted',
    'servicos.apagar.mensagemPadrao': 'Service {{nome}} is the default. Without it, trips without a service and its descriptions show as No service in the Trips panel again.',
    'servicos.page.padrao': 'Default',
    'servicos.page.padraoDica': 'Receives every trip without a service: the one without a description and the one whose description is not allocated yet.',
    'servicos.resumo.viagensNoPadrao': 'Trips in the default',
    'servicos.livres.dicaPadrao': 'Every trip with these descriptions shows as {{nome}} in the Trips panel until it is allocated.',
    'servicos.livres.semDescricaoPadrao_one': '{{count}} trip came from the ERP without a description and shows as {{nome}}.',
    'servicos.livres.semDescricaoPadrao_other': '{{count}} trips came from the ERP without a description and show as {{nome}}.',
    'servicos.dialogo.padrao': 'Default service',
    'servicos.dialogo.padraoDica': 'Receives every trip without a service, the one without a description and the one whose description is not allocated yet. Only one service can be the default.',
    'servicos.dialogo.padraoMove': 'Today the default is {{nome}}. Saving moves the mark to this service.',
    'servicos.dialogo.papel': 'Trip rule',
    'servicos.dialogo.papelNenhuma': 'None',
    'servicos.dialogo.papelDica': 'The place of this service in the rules of the Trips module, such as UBS Time and the Protheus files, which apply to Ear corn only. The service name can change without turning the rule off.',
    'servicos.papel.espiga': 'Ear corn',
    'servicos.papel.prancha': 'Flatbed',
    'servicos.papel.diaria': 'Daily allowance',
    'servicos.papel.outros': 'Others',
    'servicos.page.papelDica': 'Trip rule of this service',
    'servicos.page.novoInterno': 'New in Other Services',
    'servicos.page.grupoInterno': 'Other Services',
    'servicos.page.internoDica': 'Internal HUB service. It does not go to Protheus and is used to manually assign trips in Others or without a service.',
    'servicos.page.internoSemDescricao': 'Internal to the HUB, no ERP description',
    'servicos.dialogo.novoInterno': 'New in Other Services',
    'servicos.dialogo.internoExplica': 'One of the HUB Other Services, such as Tire. It gets no ERP description and does not go to Protheus: it appears in the manual assignment of trips in Others, General Transport or without a service.',
  },
  es: {
    'servicos.page.title': 'Servicios',
    'servicos.page.novo': 'Nuevo servicio',
    'servicos.page.busca': 'Buscar servicio o descripción...',
    'servicos.page.col.servico': 'Servicio',
    'servicos.page.col.descricoes': 'Descripciones del ERP',
    'servicos.page.col.viagens': 'Viajes',
    'servicos.page.semDescricao': 'Ninguna descripción asignada',
    'servicos.page.vazio': 'Ningún servicio registrado todavía.',
    'servicos.page.vazioBusca': 'Ningún servicio para "{{busca}}".',
    'servicos.page.viagens_one': '{{count}} viaje',
    'servicos.page.viagens_other': '{{count}} viajes',
    'servicos.resumo.servicos': 'Servicios',
    'servicos.resumo.descricoes': 'Descripciones del ERP',
    'servicos.resumo.semServico': 'Descripciones sin servicio',
    'servicos.resumo.viagensSemServico': 'Viajes sin servicio',
    'servicos.livres.titulo': 'Descripciones sin servicio',
    'servicos.livres.dica': 'Todo viaje con estas descripciones aparece como Sin servicio en el Panel de Viajes.',
    'servicos.livres.tudoAlocado': 'Todas las descripciones del ERP ya tienen servicio.',
    'servicos.livres.nenhuma': 'Ninguna descripción de servicio llegó del ERP todavía.',
    'servicos.livres.semDescricao_one': '{{count}} viaje llegó del ERP sin descripción y también aparece como Sin servicio.',
    'servicos.livres.semDescricao_other': '{{count}} viajes llegaron del ERP sin descripción y también aparecen como Sin servicio.',
    'servicos.dialogo.novo': 'Nuevo servicio',
    'servicos.dialogo.editar': 'Editar servicio',
    'servicos.dialogo.nome': 'Nombre del servicio',
    'servicos.dialogo.nomeDica': 'Cómo la operación llama al servicio, por ejemplo Cama baja.',
    'servicos.dialogo.nomeObrigatorio': 'Informe el nombre del servicio',
    'servicos.dialogo.descricoes': 'Descripciones del ERP',
    'servicos.dialogo.descricoesDica': 'Solo aparecen las descripciones sin servicio y las de este servicio.',
    'servicos.dialogo.semOpcoes': 'Ninguna descripción libre',
    'servicos.dialogo.escolhidas': 'Descripciones elegidas',
    'servicos.dialogo.nenhumaEscolhida': 'Ninguna descripción elegida. El servicio puede guardarse así y recibir descripciones después.',
    'servicos.dialogo.totalDescricoes': 'Descripciones',
    'servicos.dialogo.totalViagens': 'Viajes',
    'servicos.dialogo.remover': 'Quitar {{descricao}} del servicio',
    'servicos.dialogo.criado': 'Servicio {{nome}} creado',
    'servicos.dialogo.salvo': 'Servicio {{nome}} guardado',
    'servicos.apagar.titulo': 'Eliminar servicio',
    'servicos.apagar.mensagem': 'El servicio {{nome}} sale del registro, y sus descripciones vuelven a Sin servicio, junto con los viajes que las llevan.',
    'servicos.apagar.apagado': 'Servicio {{nome}} eliminado',
    'servicos.apagar.mensagemPadrao': 'El servicio {{nome}} es el predeterminado. Sin él, los viajes sin servicio y sus descripciones vuelven a aparecer como Sin servicio en el Panel de Viajes.',
    'servicos.page.padrao': 'Predeterminado',
    'servicos.page.padraoDica': 'Recibe todo viaje sin servicio: el que llegó sin descripción y el de descripción todavía no asignada.',
    'servicos.resumo.viagensNoPadrao': 'Viajes en el predeterminado',
    'servicos.livres.dicaPadrao': 'Todo viaje con estas descripciones aparece como {{nome}} en el Panel de Viajes hasta ser asignado.',
    'servicos.livres.semDescricaoPadrao_one': '{{count}} viaje llegó del ERP sin descripción y aparece como {{nome}}.',
    'servicos.livres.semDescricaoPadrao_other': '{{count}} viajes llegaron del ERP sin descripción y aparecen como {{nome}}.',
    'servicos.dialogo.padrao': 'Servicio predeterminado',
    'servicos.dialogo.padraoDica': 'Recibe todo viaje sin servicio, el que llegó sin descripción y el de descripción todavía no asignada. Solo un servicio puede ser el predeterminado.',
    'servicos.dialogo.padraoMove': 'Hoy el predeterminado es {{nome}}. Guardar mueve la marca a este servicio.',
    'servicos.dialogo.papel': 'Regla de viaje',
    'servicos.dialogo.papelNenhuma': 'Ninguna',
    'servicos.dialogo.papelDica': 'El lugar de este servicio en las reglas del módulo de Viajes, como el Tiempo UBS y los archivos de Protheus, que valen solo para Mazorca. El nombre del servicio puede cambiar sin apagar la regla.',
    'servicos.papel.espiga': 'Mazorca',
    'servicos.papel.prancha': 'Plataforma',
    'servicos.papel.diaria': 'Viático',
    'servicos.papel.outros': 'Otros',
    'servicos.page.papelDica': 'Regla de viaje de este servicio',
    'servicos.page.novoInterno': 'Nuevo en Otros Servicios',
    'servicos.page.grupoInterno': 'Otros Servicios',
    'servicos.page.internoDica': 'Servicio interno del HUB. No va a Protheus y sirve a la asignación manual de viajes en Otros o sin servicio.',
    'servicos.page.internoSemDescricao': 'Interno del HUB, sin descripción del ERP',
    'servicos.dialogo.novoInterno': 'Nuevo en Otros Servicios',
    'servicos.dialogo.internoExplica': 'Uno de los Otros Servicios del HUB, como Neumático. No recibe descripción del ERP y no va a Protheus: aparece en la asignación manual de viajes en Otros, en Transporte en General o sin servicio.',
  },
}
